import { Mention } from '@tiptap/extension-mention'

export const UserMentionSchema = Mention.extend({
  name: 'user-mention',
})
